module.exports = __webpack_public_path__ + "static/media/main.d22e5fcc.png";